import { create } from "zustand";
import type { MobileMenuStoreProps } from "./MobileMenuStore.d";

export const useMobileMenuStore = create<MobileMenuStoreProps>((set) => ({
  isOpen: false,
  content: null,
  close: () => set(() => ({ isOpen: false })),
  openMobileMenu: (content) => {
    set(() => ({ isOpen: true, content }));
  },
}));
